import { IS_PREVIEW_BLURRED_KEY } from '@apps/admin/routes/WebsiteEditor/routes/WebsiteEditorCustomPageV2/components/CustomPageLeftPanel/components/CustomComponents/TravelMap/components/VenueInfo/VenueInfo.constants';
import { createPreviewMessageEventHandler, MessageSetPageBlur, PreviewIframeMessage } from '@shared/utils/previewMessageBus';
import { useEffect, useState } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';

const UseIsPreviewBlurred = () => {
  const { eventInfo } = useEventInfo();
  const [isBlurred, setIsBlurred] = useState(false);

  useEffect(() => {
    const handleMessage = createPreviewMessageEventHandler((message: PreviewIframeMessage) => {
      if (message.action === 'setPageBlur' && message.source === 'joy') {
        setIsBlurred((message as MessageSetPageBlur).value.isBlurred);
      }
    }, 'joy');
    if (localStorage.getItem(IS_PREVIEW_BLURRED_KEY(eventInfo?.eventId)) === 'true') {
      setIsBlurred(true);
    }

    window.addEventListener('message', handleMessage, false);
    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, [eventInfo?.eventId]);

  return isBlurred;
};

export default UseIsPreviewBlurred;
